module.exports = __webpack_public_path__ + "static/media/greeting-splash-screen-bg.68cd6306.png";